import { render, staticRenderFns } from "./UploadFileModal.vue?vue&type=template&id=5230fb00&scoped=true"
import script from "./UploadFileModal.vue?vue&type=script&lang=js"
export * from "./UploadFileModal.vue?vue&type=script&lang=js"
import style0 from "./UploadFileModal.vue?vue&type=style&index=0&id=5230fb00&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5230fb00",
  null
  
)

export default component.exports